import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable()
export class FileSaverService {
  public saveFile(result: Blob, fileName: string) {
    saveAs(result, fileName);
  }
}
